
import { useEffect } from "react";
import HowStudentDoing from "../../../../components/Insights/Admin/HowStudentDoing";
import SchoolWork from "../../../../components/Insights/SchoolWork/SchoolWork";
import HowTheyLearning from "../../../../components/Insights/StoriesSnapShot/HowTheyLearning";
import LearnersCreating from "../../../../components/Insights/StoriesSnapShot/LearnersCreating";
import { useMetrics } from "../../../../hooks/useMetrics";
import { useDashboardFeed } from "../../../../hooks/useSchoolFeed";

function StudentView({name,data}:{name:string,data:any}) {
const schoolHash = data?.schoolHash;
const grade= data?.grade;
const studentId = data?.studentId;
const range=data?.range;

const { data:feedData,refetch:dashFetch,loading:feedloading,fetchMoreFeed } = useDashboardFeed({
  feedScopeType: "user",
  studentId: studentId,
  enabled: !!studentId
});

const { data:metricsData,loading:mLoading,refetch:matricsFetch} = useMetrics({
  scope: "student",
  schoolHash: schoolHash,
  grade: grade,
  studentId: studentId,
  range:range,
  enabled: !!schoolHash && !!grade && !!studentId
});

// useEffect(()=>{
//   if(schoolHash && grade && studentId){
//     dashFetch()
//     matricsFetch()
//   }
// },[schoolHash,grade,studentId,range])

const title = `${name}'s` + " work"
  return (
    <>
      <LearnersCreating loading={mLoading} isstoryProgress={true} name={name} classroomData={metricsData} />
      <HowStudentDoing  studentName={name} data={metricsData} />
      <HowTheyLearning loading={mLoading}  isSchool={true} learningData={metricsData} name={name} />
      <SchoolWork  title={title} loading={feedloading} fetchMoreFeed={fetchMoreFeed} feedData={feedData} />
    </>  
  );
}

export default StudentView;
